videojs.addLanguage('en', {
  "title_share": "Social networks",
  "subtitle": "Share on :"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_share/dist/lang/en.js
// module id = 541
// module chunks = 39